import { config } from '@app/config';
import { isValidUrl } from '@app/utils';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import React from 'react';
const Item = /*#__PURE__*/styled("li")({
  name: "Item",
  class: "ibmz4fe",
  vars: {
    "ibmz4fe-0": [({
      bg
    }) => bg ? bg : '#F4F4F4'],
    "ibmz4fe-1": [({
      isAgent
    }) => isAgent ? '-20px' : 'right']
  }
});
const A = /*#__PURE__*/styled("a")({
  name: "A",
  class: "am3px05"
});
const NewLabel = /*#__PURE__*/styled("div")({
  name: "NewLabel",
  class: "nsv0v4f"
});
const CategoryText = /*#__PURE__*/styled("div")({
  name: "CategoryText",
  class: "cmomclx",
  vars: {
    "cmomclx-0": [({
      color
    }) => color ? color : '#222222'],
    "cmomclx-1": [({
      isPro
    }) => isPro ? 700 : 400]
  }
});
const CategorySubText = /*#__PURE__*/styled("div")({
  name: "CategorySubText",
  class: "c1kk05bw",
  vars: {
    "c1kk05bw-0": [({
      color
    }) => color ? color : '#222222']
  }
});
const ToolItem = ({
  textColor = '#222222',
  mainText,
  subText,
  subTextColor,
  url,
  isNew,
  background = '#F4F4F4',
  onClickShortcut,
  type,
  isMobile,
  appBackground
}) => {
  let backgroundClass = background;
  if (background && isValidUrl(background)) {
    backgroundClass = `url(${isMobile ? appBackground : background})`;
  }
  const domain = url?.split('/').slice(1) ? url.split('/').slice(1)[1] : '';
  const isNofollow = !!domain && !config.jobURL.includes(domain);
  return <Item className="slider-item" bg={backgroundClass}>
      <A onClick={() => onClickShortcut(type)} aria-label={mainText} href={url} rel={isNofollow ? 'nofollow' : null}>
        <CategoryText color={textColor} isPro={type === 'pro'}>
          {mainText}
        </CategoryText>
        <CategorySubText color={subTextColor}>{subText}</CategorySubText>
      </A>
      {isNew && <NewLabel>
          <div>Mới</div>
        </NewLabel>}
    </Item>;
};
export default ToolItem;

require("../../../../.linaria-cache/src/components/RecruitmentHub/Tool/ToolItem.linaria.module.css");